/* Christina — PRO CART GUARD  v1.5 (2026-08-26, T68 — warstwa 5 tylko dla koszyka z Pro)
 * ---------------------------------------------------------------------------
 * T68-INLINE (2026-08-26) — WARSTWA 5 PRZECHWYTYWALA KLIK U CALEGO DETALU
 *
 *   Diagnoza: listener click (warstwa 5) robil preventDefault() +
 *   stopImmediatePropagation() dla KAZDEGO klienta nie-B2B, niezaleznie od tego,
 *   co ma w koszyku. Blokada dotyczy 143 produktow Pro, a koszyk detalisty
 *   praktycznie nigdy ich nie zawiera. Koszt ponosil caly ruch:
 *     - do 2500 ms (SWEEP_TIMEOUT_MS) martwego przycisku bez stanu ladowania,
 *     - stopImmediatePropagation() kasowal telemetrie begin_checkout (GA4/GTM),
 *       przez co lejek w analityce byl zanizony.
 *   Naprawa: flaga cartHasLocked utrzymywana przez sweep() (ktory i tak pobiera
 *   /cart.js). Gdy jest jednoznacznie false — klik idzie natywnie, bez
 *   przechwycenia. Gdy true albo null (nie wiadomo) — zachowanie jak w v1.4.
 *   Warstwy 1-4 i webhook orders/create pozostaja bez zmian.
 * ---------------------------------------------------------------------------
 * T64-INLINE (2026-08-21) — KLIENT NIE MOGL PRZEJSC DO KASY
 *
 *   [T64-1] Diagnoza: warstwa 5 (blokada checkoutu) przechwytywala klikniecie w
 *   <button name="checkout" type="submit" form="cart"> dla KAZDEGO klienta
 *   nie-B2B (guard wlaczony dla ~100% ruchu detalicznego), robila
 *   preventDefault() + stopImmediatePropagation(), a nastepnie wysylala
 *   formularz przez HTMLFormElement.submit().
 *   HTMLFormElement.submit() NIE serializuje pary name/value przycisku
 *   submitujacego, wiec POST /cart szedl BEZ pola `checkout`. Shopify
 *   traktowal to jako zwykla aktualizacje koszyka i przekierowywal z powrotem
 *   na /cart. Dowod (produkcja 2026-08-21):
 *     POST /cart bez `checkout` -> https://christinacosmetics.pl/cart
 *     POST /cart z   `checkout` -> https://christinacosmetics.pl/checkouts/cn/...
 *   Skutek: przycisk „Dokoncz transakcje" na /cart i w cart-drawer nie robil
 *   nic poza przeladowaniem koszyka. Zero mozliwosci zaplaty przez sklep.
 *   Naprawa: goCheckout() dokleja ukryte pole `checkout` i wysyla formularz
 *   przez form.submit().
 *
 *   [T64-2] sweep() dostal twardy timeout 2500 ms — zawieszony /cart.js nie moze
 *   juz uwiezic klienta na stronie koszyka.
 *
 *   [T64-3] Kazda sciezka bledu konczy sie przejsciem do kasy (warstwa serwerowa
 *   webhook orders/create pozostaje autorytatywna dla produktow Pro).
 *
 *   [T64-4] Diagnoza: po usunieciu pozycji Pro przez sweep strona /cart NIE
 *   przerenderowuje sie (cart:refresh obsluguje tylko <cart-drawer>). W DOM
 *   zostaje stara lista pozycji, a przycisk „Dokoncz transakcje" zostaje z
 *   atrybutem disabled ustawionym na czas POST /cart/update.js i nikt go juz
 *   nie zdejmuje. Klient z produktem Pro w koszyku utykal na /cart z martwym
 *   przyciskiem. Naprawa: na /cart przeladowujemy strone po sweepie i
 *   odtwarzamy komunikat z sessionStorage; poza /cart odblokowujemy przycisk,
 *   o ile w koszyku cos jeszcze zostalo.
 *
 *   [T64-5] Diagnoza (retest v1.3): form.requestSubmit(el) emituje ANULOWALNE
 *   zdarzenie submit. Runtime koszyka motywu (assets/christina-cart-runtime.js)
 *   podpina wlasny handler submit na formularzu #cart i w wyscigu z ladowaniem
 *   strony potrafi je anulowac — klik konczyl sie brakiem nawigacji (1 na kilka
 *   prob). Naprawa: requestSubmit NIE jest uzywany; zawsze ukryte pole +
 *   form.submit(), ktore w ogole nie emituje zdarzenia submit i nie da sie go
 *   anulowac. Dodatkowo bezwarunkowy bezpiecznik: jesli po 2,5 s adres strony
 *   sie nie zmienil, przechodzimy na /checkout.
 * ---------------------------------------------------------------------------
 * Zadanie: klient bez uprawnienia B2B nie moze wprowadzic produktu Professional
 * do koszyka ani przejsc z nim do checkoutu.
 *
 * JEDNO ZRODLO PRAWDY uprawnienia: customer.b2b? (przypisanie do Company
 * z lokalizacja majaca OBA katalogi Pro). Tag pro_approved NIE odblokowuje.
 *
 * Lista zablokowanych wariantow: shop metafield christina.pro_locked_variants,
 * odswiezany cotygodniowo przez Tools\pro-b2b-monitor\monitor.js
 * (scheduled task christina-pro-b2b-integrity).
 *
 * Warstwy:
 *   1) przechwycenie fetch()            -> /cart/add(.js), /cart/change(.js), /cart/update(.js)
 *   2) przechwycenie XMLHttpRequest     -> j.w.
 *   3) przechwycenie submit formularzy  -> form[action*="/cart/add"] (faza capture)
 *   4) sweep koszyka przy kazdym wejsciu na strone + po kazdej mutacji koszyka
 *   5) blokada przejscia do /checkout dopoki koszyk nie jest czysty
 *
 * UWAGA — granica techniczna (udokumentowana w raporcie T62):
 * surowy POST /cart/add.js z curl-a (poza przegladarka) nadal zwroci 200,
 * bo Shopify nie udostepnia walidacji koszyka per audytorium bez Shopify Function.
 * Ten przypadek domyka warstwa serwerowa: webhook orders/create w christina-backend.
 */
(function () {
  'use strict';

  var G = window.__CC_PRO_GUARD;
  if (!G || G.enabled !== true) return;               // B2B / brak danych -> guard wylaczony

  var LOCKED = Object.create(null);
  var n = 0;
  (G.locked || []).forEach(function (id) { LOCKED[String(id)] = 1; n++; });
  if (n === 0) return;

  var MSG = G.msg || 'Ten produkt jest dostepny wylacznie dla zweryfikowanych klientow profesjonalnych.';
  var CTA = G.cta || 'Zweryfikuj firme';
  var PRO_URL = G.url || '/pages/prowadze-salon-gabinet-firme';
  var SWEEP_TIMEOUT_MS = 2500;                        // T64-2
  var NAV_FAILSAFE_MS = 2500;                         // T64-5
  var NOTICE_FLAG = 'cc_proguard_notice';             // T64-4

  var _fetch = window.fetch ? window.fetch.bind(window) : null;
  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;

  function isLocked(id) { return LOCKED[String(parseInt(id, 10))] === 1; }

  function isCartPage() { return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(window.location.pathname); }

  function isCartWrite(url) {
    var u = String(url || '');
    return /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(u);
  }

  /* Wyciaga id wariantow z dowolnego ksztaltu payloadu Ajax Cart API. */
  function idsFromPayload(body) {
    var ids = [];
    try {
      var data = body;
      if (typeof body === 'string') {
        var t = body.trim();
        if (t.charAt(0) === '{' || t.charAt(0) === '[') {
          data = JSON.parse(t);
        } else {                                       // application/x-www-form-urlencoded
          var p = new URLSearchParams(t);
          if (p.get('id')) ids.push(p.get('id'));
          p.forEach(function (v, k) { if (/^items\[\d+\]\[id\]$/.test(k)) ids.push(v); });
          return ids;
        }
      } else if (body instanceof FormData) {
        var fd = body.get('id'); if (fd) ids.push(fd);
        body.forEach(function (v, k) { if (/^items\[\d+\]\[id\]$/.test(k)) ids.push(v); });
        return ids;
      } else if (body instanceof URLSearchParams) {
        return idsFromPayload(body.toString());
      }
      if (data && typeof data === 'object') {
        if (data.id != null) ids.push(data.id);
        if (Array.isArray(data.items)) {
          data.items.forEach(function (i) { if (i && i.id != null) ids.push(i.id); });
        }
      }
    } catch (e) { /* nieparsowalne -> przepusc, sweep i tak posprzata */ }
    return ids;
  }

  function payloadBlocked(body) {
    var ids = idsFromPayload(body);
    for (var i = 0; i < ids.length; i++) if (isLocked(ids[i])) return true;
    return false;
  }

  /* --- komunikat ---------------------------------------------------------- */
  var noticeEl = null;
  function notice() {
    if (noticeEl) { noticeEl.hidden = false; clearTimeout(noticeEl._t); noticeEl._t = setTimeout(hide, 9000); return; }
    if (!document.body) return;
    noticeEl = document.createElement('div');
    noticeEl.setAttribute('role', 'alert');
    noticeEl.className = 'cc-proguard-notice';
    noticeEl.style.cssText = [
      'position:fixed', 'left:50%', 'bottom:24px', 'transform:translateX(-50%)',
      'z-index:2147483000', 'max-width:min(560px,calc(100vw - 32px))',
      'background:#faf9f4', 'border:1px solid #e6e1d5', 'color:#535458',
      "font-family:'Raleway','Helvetica Neue',Arial,sans-serif", 'font-size:0.92rem',
      'line-height:1.5', 'padding:16px 16px', 'display:flex', 'gap:12px',
      'align-items:center', 'justify-content:space-between', 'flex-wrap:wrap',
      'box-shadow:0 8px 32px rgba(0,0,0,.10)'
    ].join(';');
    var span = document.createElement('span');
    span.textContent = MSG;
    var a = document.createElement('a');
    a.href = PRO_URL;
    a.textContent = CTA;
    a.style.cssText = 'color:#000;text-decoration:underline;white-space:nowrap;font-weight:500';
    var b = document.createElement('button');
    b.type = 'button';
    b.setAttribute('aria-label', 'Zamknij');
    b.textContent = '×';
    b.style.cssText = 'background:none;border:0;color:#535458;font-size:1.25rem;line-height:1;cursor:pointer;padding:0 4px';
    b.addEventListener('click', hide);
    noticeEl.appendChild(span); noticeEl.appendChild(a); noticeEl.appendChild(b);
    document.body.appendChild(noticeEl);
    noticeEl._t = setTimeout(hide, 9000);
  }
  function hide() { if (noticeEl) noticeEl.hidden = true; }

  /* T64-4: komunikat przetrwa przeladowanie /cart po sweepie. */
  function noticeAfterReload() {
    try {
      if (sessionStorage.getItem(NOTICE_FLAG)) {
        sessionStorage.removeItem(NOTICE_FLAG);
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function () { notice(); });
        } else { notice(); }
      }
    } catch (e) {}
  }
  noticeAfterReload();

  /* T64-4: przycisk kasy zablokowany na czas POST /cart/update.js nie ma kto odblokowac. */
  function reenableCheckoutButtons() {
    try {
      var list = document.querySelectorAll('button[name="checkout"]');
      for (var i = 0; i < list.length; i++) {
        list[i].disabled = false;
        list[i].removeAttribute('disabled');
        list[i].setAttribute('aria-disabled', 'false');
      }
    } catch (e) {}
  }

  function reject() {
    notice();
    var payload = { status: 422, message: 'Pro product blocked', description: MSG };
    return Promise.resolve(new Response(JSON.stringify(payload), {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    }));
  }

  /* --- 1) fetch ----------------------------------------------------------- */
  if (_fetch) {
    window.fetch = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        if (isCartWrite(url)) {
          var body = (init && init.body) || (input && input.body) || null;
          if (body && payloadBlocked(body)) return reject();
        }
      } catch (e) { /* nie blokuj sklepu na wlasnym bledzie */ }
      return _fetch(input, init);
    };
  }

  /* --- 2) XMLHttpRequest -------------------------------------------------- */
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ccUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (isCartWrite(this.__ccUrl) && body && payloadBlocked(body)) {
        notice();
        var self = this;
        Object.defineProperty(self, 'status', { value: 422, configurable: true });
        Object.defineProperty(self, 'responseText', { value: JSON.stringify({ description: MSG }), configurable: true });
        setTimeout(function () {
          try { self.dispatchEvent(new Event('error')); self.dispatchEvent(new Event('loadend')); } catch (e) {}
        }, 0);
        return;
      }
    } catch (e) {}
    return _send.apply(this, arguments);
  };

  /* --- 3) formularze ------------------------------------------------------ */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = f.getAttribute('action') || '';
    if (!/\/cart\/add/.test(action)) return;
    var ids = [];
    var idField = f.querySelector('[name="id"]');
    if (idField && idField.value) ids.push(idField.value);
    f.querySelectorAll('[name^="items["][name$="[id]"]').forEach(function (el) { if (el.value) ids.push(el.value); });
    for (var i = 0; i < ids.length; i++) {
      if (isLocked(ids[i])) { ev.preventDefault(); ev.stopImmediatePropagation(); notice(); return; }
    }
  }, true);

  /* --- 4) sweep koszyka --------------------------------------------------- */
  var sweeping = false;
  /* T68: null = nie sprawdzono, true = koszyk zawiera wariant Pro, false = czysty. */
  var cartHasLocked = null;
  function sweep() {
    if (sweeping || !_fetch) return Promise.resolve(0);
    sweeping = true;
    return _fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) { cartHasLocked = false; return 0; }
        var updates = {};
        var hit = 0;
        cart.items.forEach(function (it) {
          if (isLocked(it.variant_id || it.id)) { updates[it.key] = 0; hit++; }
        });
        cartHasLocked = hit > 0;
        if (!hit) return 0;
        var remaining = cart.items.length - hit;
        return _fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          /* cart:refresh obsluguje <cart-drawer> (assets/cart.js), ktory czyta
             event.detail.open — CustomEvent bez detail rzucal TypeError w listenerze
             (wyjatek listenera idzie do window.onerror, wiec try/catch go NIE lapie). */
          try {
            if (document.querySelector('cart-drawer')) {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
            }
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } catch (e) {}

          /* T64-4 */
          if (isCartPage()) {
            try { sessionStorage.setItem(NOTICE_FLAG, '1'); } catch (e) {}
            setTimeout(function () { window.location.reload(); }, 800);
          } else {
            notice();
            if (remaining > 0) setTimeout(reenableCheckoutButtons, 600);
          }
          return hit;
        });
      })
      .catch(function () { cartHasLocked = null; return 0; })
      .then(function (v) { sweeping = false; return v; });
  }

  /* T64-2: sweep nie moze uwiezic klienta — po SWEEP_TIMEOUT_MS idziemy dalej. */
  function sweepOrTimeout() {
    return new Promise(function (resolve) {
      var done = false;
      var t = setTimeout(function () { if (!done) { done = true; sweeping = false; resolve(0); } }, SWEEP_TIMEOUT_MS);
      sweep().then(function (v) {
        if (!done) { done = true; clearTimeout(t); resolve(v); }
      }, function () {
        if (!done) { done = true; clearTimeout(t); resolve(0); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sweep(); });
  } else {
    sweep();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sweep(); });
  document.addEventListener('cart:updated', function () { setTimeout(sweep, 400); });

  /* --- 5) blokada checkoutu ----------------------------------------------- */
  /* T64-1 + T64-5: HTMLFormElement.submit() gubi name/value submittera — bez pola
     `checkout` POST /cart wraca na /cart. Dokladamy pole recznie. requestSubmit()
     celowo NIE jest uzywany: emituje anulowalne zdarzenie submit, ktore w wyscigu
     z ladowaniem strony przechwytuje runtime koszyka motywu. */
  function goCheckout(el) {
    var startUrl = window.location.href;
    function failsafe() {
      setTimeout(function () {
        if (window.location.href === startUrl) { window.location.href = '/checkout'; }
      }, NAV_FAILSAFE_MS);
    }
    try {
      if (el.tagName === 'A') {
        window.location.href = el.getAttribute('href') || '/checkout';
        return;
      }
      var form = el.form || (el.closest ? el.closest('form') : null);
      if (!form) { window.location.href = '/checkout'; return; }

      var fieldName = el.getAttribute('name') || 'checkout';
      var fieldValue = (el.value == null) ? '' : el.value;
      if (!form.querySelector('input[type="hidden"][name="' + fieldName + '"]')) {
        var h = document.createElement('input');
        h.type = 'hidden';
        h.name = fieldName;
        h.value = fieldValue;
        form.appendChild(h);
      }
      form.submit();
      failsafe();
    } catch (e) {
      window.location.href = '/checkout';
    }
  }

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[name="checkout"],a[href*="/checkout"],button[href*="/checkout"]') : null;
    if (!el) return;
    /* T68: koszyk sprawdzony i czysty -> nie dotykamy klikniecia. Natywny submit,
       pelna telemetria, zero opoznienia. Przy true/null zostaje sciezka v1.4. */
    if (cartHasLocked === false) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    sweepOrTimeout().then(function (removed) {
      if (removed > 0) { notice(); return; }               // koszyk wyczyszczony — uzytkownik klika ponownie
      goCheckout(el);
    }, function () { goCheckout(el); });
  }, true);

  window.__ccProGuardSweep = sweep;                          // do diagnostyki
  window.__ccProGuardVersion = '1.5';
  window.__ccProGuardCartState = function () { return cartHasLocked; };   // diagnostyka
})();
